import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import marutibreeza from "../../../assets/images/maruti-breeza.png";
import BookedCar from "../../../components/comment/bookedcar/bookedCar";
import MainFeature from "../../../components/comment/carfeature/mainFeature";
import StartEndTrip from "../../../components/comment/startendtrip/startEndTrip";
import CheckoutTripDetail from "../Tripdetail/TripDetail"

const bookingDetail = () => {
  return (
    <section className="booking-detail">
      <div className="title">
        <Row>
          <Col md={4}><div class="Breezaa">Maruti Breeza </div></Col>
          <Col md={8}><div class="Breezaa">Booking Details </div></Col>
        </Row>
      </div>

      <div className="feature-component">
        <Row>
          <Col md={4} className="d-flex justify-content-center">
            {" "}
            <div className="car-feature-checkout-wrap">
              <div className="car-image ">
                <BookedCar img={marutibreeza} />
              </div>
              <div className="main-feature ">
                <MainFeature />
              </div>
            </div>
          </Col>
          <Col md={8}>
          <div className="start-end-status">
          
            <StartEndTrip />

          </div>

          <div className="trip-details">
            <CheckoutTripDetail />
          </div>
          
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default bookingDetail;
